<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

<!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect-ep
        class="mt-5"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        :isNotDotInLabel="true"
        table-header-title="착안사항"
        table-header-note="개선요망 사항"
        table-header-yes="양호"
        table-header-no="미흡"
        table-header-na="해당없음"
        :is-note="true"
        @update-list-check="(param1, param2)=>{
        updateListCheck(indexRows,param1,param2
        )}"
        v-if="inspection.check"
      />
    </div>

<!--    현장근로자 의견 청취 및 특이사항-->
    <div class="grid grid-cols-12 gap-x-6">
      <vs-row class="mt-8 col-span-12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-4 flex items-center mt-4">
        <div class="label-text mr-4">현장근로자 의견 청취</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_1.fileName }}
        </p>
        <file-uploader
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_1"
          class="flex-1 w-full"
        />

      </div>
      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">특이사항</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputC_2"
          :readonly="board.readonly"
        />
      </div>
    </div>


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import FileUploader from '@/components/FileUploader'
import TableInspectEp from '@/components/TableInspectCustomEp'

export default {
  components: {
    TableInspectEp,
    FileUploader,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    updateListCheck (indexList, indexTableRows, text) {
      this.form.inspectList[indexList].list[indexTableRows].is_checked = text
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inputC_1: {},
        inputC_2: '',

        typeTitleList: [],
        inspectList: [],
        photoList: [],
        fileList: [],
      },
    };
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '작업장환경',
          check: false,
          title: '작업장환경',
          list: [
            {
              id: 1,
              label: "1. 작업장내 안전통로는 확보되어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 바닥은 미끄럽거나 넘어질 위험이 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 출입구, 비상구 주변에 물건을 두고 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "4. 이동시 바닥의 상태, 턱, 장애물 유무 확인하는 가?",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "5. 물건(이동),사용시 날카로움, 베일 우려가 있는지 확인하는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 6,
              label: "6. 계단끝단 미끄럼방지조치, 계단난간 설치 및 이동통로에 적정 조도는 확보되었는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 2,
          label: '건강상태',
          check: false,
          title: '건강상태',
          list: [
            {
              id: 1,
              label: "1. 근로자들의 휴식시간 제공과 휴게시설이 설치 되어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 근로자의 건강보호 유지를 위하여 정기적인 건강 검진을 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 3,
          label: '전기안전',
          check: false,
          title: '전기안전',
          list: [
            {
              id: 1,
              label: "1. 멀티탭 먼지없이 청결하게 유지되고 있는지 여부 확인",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 전기안전(전열기구,전선,콘센트 등)육안점검 - 문어발식 연결 상태, 전선의 피복 손상, 커버 파손 여부 등",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 전선이 꼬이거나 무거운 물건에 눌려있는지 여부 확인(육안점검)",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 4,
          label: '비상구',
          check: false,
          title: '비상구',
          list: [
            {
              id: 1,
              label: "1. 비상시 사무실 내에서 탈출할 수 있는 비상구가 마련되어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 비상구임을 알아볼 수 있는 표시를 근로자의 눈에 띄기 쉬운 곳에 부착하였는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 5,
          label: '근골격계질환',
          check: false,
          title: '근골격계질환',
          list: [
            {
              id: 1,
              label: "1. 장시간 앉아있는 자세로 작업하는가?(하루 4시간 이상)",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 하루 4시간 이상 거북목 유지 등 불안정한 자세로 작업하는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 6,
          label: '게시상태',
          check: false,
          title: '게시상태',
          list: [
            {
              id: 1,
              label: "1. 법령요지 게시 여부",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 안전보건표지 부착 여부",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 7,
          label: '안전보건교육',
          check: false,
          title: '안전보건교육',
          list: [
            {
              id: 1,
              label: "1. 안전보건교육을 정기적으로 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 신규채용자의 안전보건교육은 별도로 실시하고 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
        {
          id: 8,
          label: '소방안전',
          check: false,
          title: '소방안전',
          list: [
            {
              id: 1,
              label: "1. 소화기의 충전 상태는?",
              is_checked: "",
              note: ''
            },
            {
              id: 2,
              label: "2. 소화기 호스의 균열 및 노즐의 파손 상태는?",
              is_checked: "",
              note: ''
            },
            {
              id: 3,
              label: "3. 소화기의 월별 점검표 및 사용법 부착 상태는?",
              is_checked: "",
              note: ''
            },
            {
              id: 4,
              label: "4. 대피로는 제대로 확보 되어 있는가?",
              is_checked: "",
              note: ''
            },
            {
              id: 5,
              label: "5. 소화기는 눈에 띄는 곳에 비치되어 있는가?",
              is_checked: "",
              note: ''
            },
          ],
        },
      ]
    }
  },
};
</script>

<style scoped lang="scss">.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
